import React, { useMemo } from 'react';
import { getDealValueUSDForTotals } from '@/utils/procurementValueUsd';
import { useTranslation } from '@/components/utils/translations';

function RecentlyExpiredSummary({ deals }) {
  const { t } = useTranslation();
  const { totalDeals, totalValueUSD, totalCountries } = useMemo(() => {
    const countries = new Set();
    let total = 0;
    deals.forEach((d) => {
      if (d.country && d.country.trim()) countries.add(d.country.trim());
      total += getDealValueUSDForTotals(d);
    });
    return {
      totalDeals: deals.length,
      totalValueUSD: total,
      totalCountries: countries.size,
    };
  }, [deals]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 rounded-lg border border-gray-200 bg-[#ECFFFE]/50 p-5">
      <div className="flex flex-col gap-1">
        <span className="text-2xl font-bold text-[#0A1A2F] tabular-nums">{totalDeals.toLocaleString()}</span>
        <span className="text-sm text-gray-600">{t('deals')}</span>
      </div>
      <div className="flex flex-col gap-1 sm:border-l sm:border-gray-200 sm:pl-6">
        <span className="text-2xl font-bold text-[#0A1A2F] tabular-nums">
          {totalValueUSD > 0 ? '$' + totalValueUSD.toLocaleString(undefined, { maximumFractionDigits: 0 }) : '—'}
        </span>
        <span className="text-sm text-gray-600">{t('procMapTotalValueUsd')}</span>
      </div>
      <div className="flex flex-col gap-1 sm:border-l sm:border-gray-200 sm:pl-6">
        <span className="text-2xl font-bold text-[#0A1A2F] tabular-nums">{totalCountries.toLocaleString()}</span>
        <span className="text-sm text-gray-600">{t('procMapCountries')}</span>
      </div>
    </div>
  );
}

export default RecentlyExpiredSummary;
